export function getUserErrorMessage(error) {
  if (error?.isAxiosError || error?.name === 'AxiosError') {
    const status = error.response?.status;
    if (!error.response) {
      return error.code === 'ECONNABORTED' || error.code === 'ETIMEDOUT' ? '请求超时，请稍后重试。' : '连接失败，请检查网络后重试。';
    }
    if (status === 401) return '登录已过期，请重新登录。';
    if (status === 405) return '当前操作暂不支持，请刷新页面后重试。';
    if (status === 429) return '请求过于频繁，请稍后重试。';
    if (status >= 500) return '服务暂不可用，请稍后重试；如仍有问题，请联系平台支持。';
    const message = error.response?.data?.message;
    return typeof message === 'string' && message.trim() ? message : '操作未完成，请检查输入后重试。';
  }
  if (typeof error === 'string' && error.trim()) return error;
  return error?.message || '操作未完成，请重试。';
}
